var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form',{attrs:{"label-position":"top"}},[_c('el-form-item',{attrs:{"label":"Color"}},[_c('el-color-picker',{model:{value:(_vm.data.color),callback:function ($$v) {_vm.$set(_vm.data, "color", $$v)},expression:"data.color"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }